import { types } from './mutation-types';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { getMockedContractData } from '@/repositories/mockDataUtils';

const shop = RepositoryFactory.get('customer');

export const customer = {
  namespaced: true,
  // initial state
  state: {
    contract: null,
    loaded: false,
    choosen_contract_id: null,
  },
  getters: {
    getContracts: state => state.contract,
  },
  actions: {
    getCustomerContract({ commit }) {
      shop.getCustomerContract().then((response) => {
        commit(types.SET_CUSTOMER_CONTRACT, response.data);
        commit(types.SET_LOADED, true);
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error.message);
      });
    },
    setCustomerContract({ commit }, contract) {
      commit(types.SET_CUSTOMER_CONTRACT, contract);
      commit(types.SET_LOADED, true);
    },
    /*
    * Action to get a mocked contract data
    * */
    getMockedCustomerContract({ commit }) {
      commit(types.SET_CUSTOMER_CONTRACT, getMockedContractData);
      commit(types.SET_LOADED, true);
    },
    setChosenContract({ commit }, contractId) {
      commit(types.SET_CHOSEN_CONTRACT, contractId);
    },
  },
  mutations: {
    [types.SET_CUSTOMER_CONTRACT](state, data) {
      state.contract = data;
    },
    [types.SET_LOADED](state, value) {
      state.loaded = value;
    },
    [types.SET_CHOSEN_CONTRACT](state, value) {
      state.choosen_contract_id = value;
    },
  },
};
